/**
 * @format
 */

import { api } from '@/scripts/api';

export const PartnerSurveySubmissionService = {
    get(instanceId, accountId) {
        return new Promise((resolve, reject) => {
            const service = `/ms/surveys/v1/instances/${instanceId}/account/${accountId}/answers`;
            api.get(service).then(resolve).catch(reject);
        });
    },

    post(instanceId, accountId, payload) {
        return new Promise((resolve, reject) => {
            const service = `/ms/surveys/v1/instances/${instanceId}/account/${accountId}/save`;
            api.post(service, payload).then(resolve).catch(reject);
        });
    },

    elapsedTime(instanceId, accountId, payload) {
        return new Promise((resolve, reject) => {
            const service = `/ms/surveys/v1/instances/${instanceId}/account/${accountId}/elapsedTime`;
            api.post(service, payload).then(resolve).catch(reject);
        });
    },

    viewed(instanceId, accountId) {
        return new Promise((resolve, reject) => {
            const service = `/ms/surveys/v1/instances/${instanceId}/account/${accountId}/view`;
            api.post(service).then(resolve).catch(reject);
        });
    },

    reminder(instanceId, accountId) {
        return new Promise((resolve, reject) => {
            const service = `/ms/surveys/v1/instances/${instanceId}/account/${accountId}/reminder`;
            api.post(service).then(resolve).catch(reject);
        });
    },

    overviewStats({ instanceId, accountId }) {
        return new Promise((resolve, reject) => {
            const service = `/ms/surveys/v1/instances/vendor/account/${accountId}/survey/${instanceId}/overview`;
            api.get(service).then(resolve).catch(reject);
        });
    },

    overviewBoard({ instanceId, accountId, options = {} }) {
        return new Promise((resolve, reject) => {
            const service = `/ms/surveys/v1/instances/vendor/account/${accountId}/survey/${instanceId}`;
            const endpoint = api.applyNodeDataParams(service, options);
            api.get(endpoint).then(resolve).catch(reject);
        });
    },
};
